import { useEffect } from "react";
import { useLocation } from "react-router-dom";

interface ScrollToTopProps {
  dependencies?: any[];
  behavior?: 'auto' | 'smooth';
}

export default function ScrollToTop({ dependencies, behavior = 'smooth' }: ScrollToTopProps = {}) {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);


  useEffect(() => {
    if (dependencies && dependencies.length > 0) {
      window.scrollTo({ top: 0, behavior });
    }
  }, dependencies ? [...dependencies, behavior] : []);
  
  return null;
}